import gql from "graphql-tag";

export default gql`
	query getSubscriptionByID($subscriptionID: Int!) {
		getSubscriptionByID(subscriptionID: $subscriptionID) {
			subscriptionID
			dateCreated
			expirationDate
			status
			archiveBit
			allowedActivations
			isAutoBillingEnabled
			isTrial
			customer {
				email
			}
			serialNumbers {
				licenseName
				serialNumber
				usedActivations
				activations {
					id
					email
					status
					version
					activated
					deactivated
					computerName
				}
				downloads {
					id
					os
					release
					releaseDate
					architectures
					minOSVersion
					minOSName
					downloadLink
				}
			}
			billingName
			billingEmail
			billingCompany
			billingDepartment
			billingAddress1
			billingAddress2
			billingCity
			billingState
			billingZipCode
			billingCountryID
			billingCountry {
				name
			}
			billingPhoneNumber
			plan {
				name
				planCode
			}
			adminEmails {
				id
				adminEmail
			}
			orders {
				orderNumber
				status
				createdBy
			}
			lastOrder {
				orderNumber
				isSerialNumberGenerationPending
			}
			allowedOperations {
				addons
				renewal
			}
		}
	}
`;

export const readSubscriptionData = ({ data }) => data && data.getSubscriptionByID;
